import { Component } from '@angular/core';

@Component({
    selector: 'mport-root',
    templateUrl: './root-container.component.html'
})
export class RootContainerComponent {}
